import { PUBLISHER_NOTIFICATION_SETTINGS_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import setUserNotificationSettings from 'root/src/client/logic/brandSettings/thunks/setUserNotificationSettings'

export default {
	[PUBLISHER_NOTIFICATION_SETTINGS_MODULE_ID]: [
		{
			action: setUserNotificationSettings,
		},
	],
}
